import { css } from '@Root/lib/lit-3form-block';

export const styles = [
  css`
    :host {
      --rose-image-height: calc(167rem / var(--default-rem-px-count));
    }

    .rose-layout {
      display: flex;
      flex-direction: column;
      gap: calc(15rem / var(--default-rem-px-count))
        var(--between-column-padding);
      padding: 0 calc(12rem / var(--default-rem-px-count));
    }

    .rose-layout.exclude-header,
    .rose-layout.include-header {
      grid-template-rows:
        var(--top-padding-height)
        minmax(0, auto)
        var(--top-padding-height)
        [last-line];
      max-width: 100%;
    }

    .scroll-buttons {
      display: none;
    }

    .scroll-buttons span {
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      height: calc(40rem / var(--default-rem-px-count));
      width: calc(40rem / var(--default-rem-px-count));
      cursor: pointer;
    }

    .scroll-buttons span img {
      height: calc(16rem / var(--default-rem-px-count));
      width: calc(8rem / var(--default-rem-px-count));
    }

    .left-arrow {
      transform: rotate(180deg);
    }

    .images {
      grid-column: 2 / 8;
      grid-row: 2;
      display: flex;
      flex-wrap: nowrap;
      overflow-x: scroll;
    }

    .images > .image {
      padding-right: 2em;
    }

    .image > img {
      margin-bottom: 1em;
      height: var(--rose-image-height);
    }

    .image-caption {
      padding-top: 1em;
      border-top: 1px solid #c0c0c0;
      display: flex;
      justify-content: space-between;
    }

    .image-caption > span > p {
      font-size: 0.825em;
      line-height: 1.45em;
      margin: 0;
    }

    .elements-colors {
      background-color: #f8f8f8;
    }

    @media (min-width: 600px) {
      :host {
        --rose-image-height: calc(300rem / var(--default-rem-px-count));
      }

      .rose-layout {
        display: inline-grid;
        grid-template-columns: var(--outer-padding) repeat(12, 1fr) var(
            --outer-padding
          );
        gap: 0 var(--between-column-padding);
        padding: unset;
      }

      .rose-layout.exclude-header {
        grid-template-areas:
          '. . . . . . . . . . scrollBtns scrollBtns scrollBtns .'
          var(--images-row-with-left-gutter)
          var(--block-line-break);
        grid-template-rows:
          var(--top-padding-height)
          minmax(0, auto)
          var(--top-padding-height)
          [last-line];
        max-width: 100%;
      }

      .rose-layout.include-header {
        grid-template-areas:
          '. header header header . description description description description . scrollBtns scrollBtns scrollBtns .'
          var(--images-row-with-left-gutter)
          var(--block-line-break);
        grid-template-rows:
          minmax(0, auto)
          minmax(0, auto)
          var(--top-padding-height)
          [last-line];
        max-width: 100%;
      }

      .rose-layout.exclude-header > .scroll-buttons,
      .rose-layout.include-header > .scroll-buttons {
        grid-area: scrollBtns;
        display: flex;
        flex-direction: row;
        justify-content: right;
        align-items: center;
      }

      .rose-layout.include-header > .header {
        grid-area: header;
        padding-bottom: calc(20rem / var(--default-rem-px-count));
      }

      .rose-layout.include-header > .description {
        grid-area: description;
        padding-bottom: calc(40rem / var(--default-rem-px-count));
      }

      .images {
        grid-area: images;
      }

      .images::-webkit-scrollbar-track {
        /*
          This is hard-coded to 34rem for now because it's based on column
          width specifically at the 1200px screen cutoff (32rem + 2rem for the
          outside columns).
        */
        margin-right: calc(34rem / var(--default-rem-px-count));
      }
    }

    @media (min-width: 1024px) {
      :host {
        --rose-image-height: calc(350rem / var(--default-rem-px-count));
      }
    }

    @media (min-width: 1200px) {
      :host {
        --rose-image-height: calc(400rem / var(--default-rem-px-count));
      }
    }
  `,
];
